const LdJSONSchemaScriptTag = ({ ldJson }) => {
  const attributes = {
    type: 'application/ld+json',
    dangerouslySetInnerHTML: { __html: JSON.stringify(ldJson) }
  };

  if (ldJson?.id) {
    return (
      <script
        key={ldJson.id}
        {...attributes}
      />
    );
  }

  return <script {...attributes} />;
};

export default LdJSONSchemaScriptTag;
